//{addResults:[{success, errorMsg, Betriebsteile:[...]}]}

class EsriBehaviour {
  static responseHandling(response) {
    return response.json().then(
      (r) =>
        new Promise((resolve, reject) => {
          const dataAttribute = r.addResults[0].dataAttribute || "Betriebsteil";
          const data =
            r.addResults.length > 0 ? r.addResults[0][dataAttribute] : [];
          resolve(data);
        })
    );

    // this.setState({
    //   data:
    //     response.addResults.length > 0
    //       ? response.addResults[0][dataAttribute]
    //       : [],
    //   refresh: false,
    //   isLoading: false,
    //   countSelected: 0,
    //   selected: [],
  }
  static isError(response) {
    return response.json().then(
      (r) =>
        new Promise((resolve, reject) => {
          resolve(!r.addResults[0].success);
        })
    );
  }
  static errorMessage(response) {
    return response.json().then(
      (r) =>
        new Promise((resolve, reject) => {
          resolve(r.addResults[0].error.description);
        })
    );
  }
}
export default EsriBehaviour;
